@use '../../assets/styles/variables' as vars;

.navbar {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  background-color: vars.$darkblue;
  display: flex;
  flex-direction: column;
  transition: left 0.3s ease-in-out;
  overflow-y: auto;
  font-weight: 300;
}

.navbar--open {
  left: 0;
  z-index: 100;
}

.navbar__links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.navbar__item {
  width: 100%;
}

.navbar__link,
.navbar__subroute-link {
  background: none;
  color: inherit;
  border: none;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  width: 100%;
  text-align: left;
  display: block;
  padding: 2rem;
  text-decoration: none;

  &:active {
    background-color: vars.$yellow;
  }
}

.navbar__subroutes {
  list-style: none;
  padding-left: 1rem;
  margin: 0;
}
